import React, { FC } from 'react';
import './CustomKeyClaims.scss';
import { useApiClientContext } from '../../store/api-client-context';
import { CustomKeyPermissions } from './CustomKeyPermissions';

interface Props {
	setSelectedPermissions: (value: any) => void,
	isEditMode: boolean;
}

export const CustomKeyClaims: FC<Props> = (props) => {
	const { setSelectedPermissions, isEditMode } = props;
	const { apiClientContextState: { resourceList }} = useApiClientContext();

	return (
		<>
			<div className="row border-bottom-separator pb-2">
				<div className="col-7 fs-5 fw-bolder">Resources</div>
				<div className="col-5 fs-5 fw-bolder">Permissions</div>
			</div>
			<div>
				{resourceList?.map(({ name, displayName, scopes }) => (
					<div key={name} className="row py-3 border-bottom-separator">
						<div className="col-7 fs-6 d-flex align-items-center">
							{displayName}
						</div>
						<div className="col-5">
							<CustomKeyPermissions
								scopes={scopes}
								setSelectedPermissions={setSelectedPermissions}
								resourceName={name}
								isEditMode={isEditMode}
							/>
						</div>
					</div>
				))}
			</div>
		</>
	);
};
